"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _system = require("@ori-ui/mui-bundle/system");
var _constants = require("../constants");
const styleOverrides = {
  root: {
    backdropFilter: 'blur(2px)',
    WebkitBackdropFilter: 'blur(2px)',
    background: (0, _system.alpha)(_constants.colors.commonColors.black, 0.45),
    '&.MuiBackdrop-invisible': {
      backdropFilter: 'unset',
      WebkitBackdropFilter: 'unset',
      background: 'none'
    }
  },
  invisible: {
    backdropFilter: 'unset',
    WebkitBackdropFilter: 'unset',
    background: 'none'
  }
};
var _default = exports.default = {
  styleOverrides
};
//# sourceMappingURL=MuiBackdrop.js.map